// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"03666aa0","308":"d8a2625b","343":"09fbe42f","704":"d9f3d4be","978":"44e83272"}[chunkId] + ".chunk.js";
};